<template>
    <div v-if="bbId || bbSpaceId">
        <component
            :is="htmlTag"
            id="bb-widget-preview"
            class="bb-widget border-0 bg-none"
            data-bb-stats="0"
            :data-bb-type="bbType === 'widget' ? undefined : bbType"
            :data-bb-popover-event="bbPopoverEvent"
            :data-bb-language="bbLanguage"
            :data-bb-id="bbId"
            :bb-space-id="bbSpaceId"
            :data-bb-oid="bbOid"
            :data-bb-number="bbNumber"
            :data-bb-name="bbName"
            :data-bb-info="bbInfo"
            :data-bb-shop-style="bbShopStyle"
            :data-bb-sort="bbSort"
            :data-bb-lead-color="bbLeadColor"
            :data-bb-button-label="bbButtonLabel"
            :data-bb-row-count="bbRowCount"
            :data-bb-show-extra="bbShowExtraValue"
            :data-bb-show-prices="bbShowPricesValue"
            :data-bb-p1="bbP1"
            :data-bb-p2="bbP2"
            :data-bb-p3="bbP3"
            :data-bb-alt="hasTrigger ? undefined : 'bb-alt'"
            :data-bb-formats="bbFormats"
            :data-bb-default-formats="bbDefaultFormats"
            data-bb-version="5.0"
            @bb-loading="onBBLoading"
            @bb-no-data="onNoData"
            @bb-loaded="onBBLoaded"
        >
            <span v-if="hasTrigger" class="preview-link">
                {{ $t('widgetPreview.show') }}
            </span>
        </component>
        <div v-if="!hasTrigger" id="bb-alt" class="title text-center bb-alt" style="display: none;">
            {{ $t('widgetPreview.noOffers') }}
        </div>
    </div>
</template>

<script>
    import { debounce } from 'lodash';
    import { isEmpty } from '@/utils/util';

    export default {
        name: 'WidgetPreview',
        props: {
            bbType: {
                validator: value => ['widget', 'popover', 'overlay', 'logos-only'].includes(value),
            },
            bbPopoverEvent: {
                type: String,
                validator: value => ['hover', 'click'].includes(value),
            },
            bbLanguage: {
                type: String,
            },
            bbId: {
                type: Number,
            },
            bbSpaceId: {
                type: Number,
            },
            bbOid: {
                type: Number,
            },
            bbNumber: {
                type: Number,
            },
            bbName: {
                type: String,
            },
            bbInfo: {
                type: String,
            },
            bbShopStyle: {
                type: String,
            },
            bbSort: {
                type: String,
            },
            bbLeadColor: {
                type: String,
            },
            bbButtonLabel: {
                type: String,
            },
            bbRowCount: {
                type: Number,
            },
            bbShowExtra: {
                type: Boolean,
                default: undefined,
            },
            bbShowPrices: {
                type: Boolean,
                default: undefined,
            },
            bbP1: {
                type: String,
            },
            bbP2: {
                type: String,
            },
            bbP3: {
                type: String,
            },
            htmlTag: {
                type: String,
                default: 'span',
            },
            reloadDelay: {
                type: Number,
                default: 1000,
            },
            bbFormats: {
                type: String,
            },
            bbDefaultFormats: {
                type: String,
            },
        },
        data() {
            return {
                reloadBBDebounced: () => {},
            };
        },
        computed: {
            bbShowExtraValue() {
                if (isEmpty(this.bbShowExtra)) {
                    return undefined;
                }
                return this.bbShowExtra ? 'product_name-info-img' : 'false';
            },
            bbShowPricesValue() {
                if (isEmpty(this.bbShowPrices)) {
                    return undefined;
                }
                return this.bbShowPrices ? 'true' : 'false';
            },
            hasTrigger() {
                return ['popover', 'overlay'].includes(this.bbType);
            },
        },
        watch: {
            hasTrigger() {
                document.getElementById(`bb-alt${this.bbId}`)?.remove();
            },
        },
        methods: {
            loadWidgetScript() {
                if (window.bb) {
                    return;
                }
                const script = document.createElement('script');
                script.src = process.env.VUE_APP_WIDGET_SCRIPT_URL;
                script.async = true;
                document.body.appendChild(script);
            },
            reloadBB() {
                document.querySelectorAll('div[id^="bb-alt"]:not(#bb-alt)')?.forEach(item => item.remove());
                if (window.bb) {
                    window.bb.forceReload();
                    this.$emit('reloadBB');
                }
            },
            onBBLoading(e) {
                this.$emit('BBLoading', e);
            },
            onNoData(e) {
                this.$emit('NoData', e);
            },
            onBBLoaded(e) {
                this.$emit('BBLoaded', e);
            },
        },
        created() {
            this.reloadBBDebounced = debounce(this.reloadBB, this.reloadDelay);
        },
        mounted() {
            this.reloadBBDebounced();
            this.loadWidgetScript();
        },
        updated() {
            this.reloadBBDebounced();
        },
    };
</script>

<style lang="scss" scoped>
    .preview-link {
        text-decoration: underline;
        color: blue;
        cursor: pointer;
    }

    #bb-widget-preview {
        ::v-deep {
            .bb-table-wrapper {
                overflow-x: auto;
                max-width: 100%;
                -webkit-overflow-scrolling: touch;
            }

            // .bb-table {
            //     .bb-table-content {
            //         display: grid;
            //         overflow: auto;

            //         a {
            //             display: contents;

            //             .bb-row {
            //                 display: flex;
            //                 gap: 0.5rem;

            //                 .bb-cell {
            //                     display: table-cell;

            //                     * {
            //                         white-space: inherit !important;
            //                         display: inline !important;
            //                         vertical-align: middle;
            //                         float: none;
            //                     }

            //                     img {
            //                         display: inline-block !important;
            //                         vertical-align: middle;
            //                     }

            //                     &.bb-store {
            //                         min-width: auto;
            //                     }

            //                     &.bb-go-to-store {
            //                         min-width: max-content;
            //                     }
            //                 }
            //             }
            //         }
            //     }
            // }
        }
    }
</style>
